const snack = require('../../../../../components/snack/snack')

export function start(detail){

      snackBody[detail.id].start(detail)

      detail.html = snackBody[detail.id]
      snack.start(detail)
}

const snackBody = {

      message: {
            title: '',
            btn:   '',
            class: ``,

            dataDetail: `data-detail='{
                  "click": [
                        {"dest":"ripple"},
                        {"dest":"snack", "act":"hide"}
                  ]}'`,

            start: function(detail){
                  this.title = detail.text
            },
      },
}
